import { Grid, Tooltip} from "@mui/material";

export function getPhpackagingmaterialStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        formid:{
            name:'formid',
            label:'Form Id',
            value:'',
            error:false,
            errorMessage:'You must enter Form Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        formname:{
            name:'formname',
            label:'Form Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:250 },
        { field: 'formname', headerName: 'Form Name', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['title']:{
          ...formValues['title'],
          value:data.title,
        },['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['formid']:{
          ...formValues['formid'],
          value:data.formid,
        },['formname']:{
          ...formValues['formname'],
          value:data.formname,
        },
      })
}